import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IdentityRequestDTO } from "../../schema/Identity/IdentityRequestDTO";
import { SessionTO } from "../../schema/Identity/SessionTO";

@Injectable({
    providedIn: "root"
})
export class ApiIdentityUserService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.identity.url}/api/v1/user`;
    }

    public Register(request: IdentityRequestDTO): Observable<SessionTO> {
        return this.httpClient.post<SessionTO>(this.relativePath, request);
    }
}
